const fleet = require('./fleet');
const iam = require('./iam');
const driver = require('./driver');
const auditLog = require('./audit-log');
const passenger = require('./passenger');
const business = require('./business');
const customer = require('./customer');
const internal = require('./internal');
const phoenix = require('./phoenix');
const marketing = require('./marketing');

module.exports = {
  fleet,
  iam,
  driver,
  auditLog,
  passenger,
  business,
  customer,
  internal,
  phoenix,
  marketing,
  ...passenger,
};
